import { styled } from 'styled-components';

export const StyledRub = styled.span`
  font-size: 0.8em;
`;
